import React from 'react';
import { useCustomTheme } from '../hooks/useCustomTheme';
import { ThemeProvider } from 'styled-components';
import { CustomProvider } from 'rsuite';
import ptBR from 'rsuite/locales/pt_BR';

export function StyledProvider({ children }) {
  const { theme, themeSchema } = useCustomTheme();
  return (
    <ThemeProvider theme={theme}>
      <CustomProvider theme={themeSchema} locale={ptBR}>{children}</CustomProvider>
    </ThemeProvider>
  );
}
